'use client';
import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

import CategoryPromotion from '../landing/components/category-promotion/CategoryPromotion';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Containers = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 50px;
`;
export const ImageDiv = styled.div<{ isDesktop?: boolean }>`
  max-height: 200px;
  height: auto;
  position: relative;
  top: 100px;
  & img {
    position: relative !important;
  }
`;
export const ContainersMobil = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const LandingContainer = styled.div`
  width: ${LANDING_BREAKPOINT};
  display: grid;
  grid-row-gap: 40px;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    width: 100%;
    grid-row-gap: 20px;
    padding: 0 10px;
  }
`;

export const CampaignPromotionsContainer = styled.div`
  padding: 0px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    margin-bottom: 20px;
  }
`;

export const LandingBannerContainer = styled.div`
  width: 100%;
  height: 400px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 285px;
  }
`;

export const HeroImageContainer = styled.div`
  visibility: visible;
  width: 100%;
  height: 100%;
`;

export type CTB_TYPES = 'primary' | 'secondary' | 'outline';

export const CTButton = styled.button<{
  btnType: CTB_TYPES;
}>`
  position: absolute;
  width: 250px;
  height: 55px;
  right: 8%;
  bottom: 34%;
  box-shadow: 0px 10px 30px
    ${({ theme, btnType }) =>
      btnType === 'primary'
        ? `rgba(255, 65, 57, 0.5)`
        : btnType === 'secondary'
        ? `rgba(58, 58, 58, 0.5)`
        : btnType === 'outline'
        ? 'transparent'
        : theme.palette.coral};

  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 900;

  background-color: ${({ theme, btnType }) =>
    btnType === 'primary'
      ? theme.palette.BR500
      : btnType === 'secondary'
      ? theme.palette.eclipse
      : btnType === 'outline'
      ? theme.palette.white
      : theme.palette.coral};

  color: ${({ theme, btnType }) =>
    btnType === 'primary'
      ? theme.palette.white
      : btnType === 'secondary'
      ? theme.palette.white
      : btnType === 'outline'
      ? theme.palette.persianRed
      : theme.palette.white};

  border: 1px solid
    ${({ theme, btnType }) =>
      btnType === 'primary'
        ? theme.palette.persianRed
        : btnType === 'secondary'
        ? theme.palette.eclipse
        : btnType === 'outline'
        ? theme.palette.persianRed
        : theme.palette.coral};

  @media (min-width: 1300px) {
    right: 9%;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_2X})`} {
    right: 14%;
    bottom: 34%;
  }
`;

export const SeoTextContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0px;
  }
`;

export const WhySeturContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 20px 0 23px 0;
  }
`;

export const TravelSuggestionsContainer = styled.div`
  width: 100%;
  max-width: 1240px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 36px 0 20px 0;
  }
`;

export const ShipTours = styled(CategoryPromotion)``;

export const HomeBookerWrapper = styled.div`
  width: fit-content;
  z-index: 200;
  max-height: 600px;
  & > div:first-of-type {
    will-change: unset !important;
    transform: unset !important;
  }
`;

export const HomeBookerWrapperMobile = styled.div`
  width: 100%;
  position: relative;
  top: 60px;
`;
export const Wrapper = styled.div`
  position: absolute;
  bottom: 20%;
  right: 10%;
`;
